import React from "react";
import { FiCheck } from "react-icons/fi";

const ProductsWeManufacture = () => {
    const products = [
        {
            category: "Cable Trays",
            items: [
                "Perforated Cable Trays",
                "Ladder Type Cable Trays",
                "Raceway Cable Trays",
                "Mesh Cable Trays",
                "FRP Cable Trays"
            ]
        },
        {
            category: "Flats",
            items: [
                "GI Flats",
                "Hot Dip Galvanized Flats",
                "Copper Flats",
                "Aluminium Flats"
            ]
        },
        {
            category: "Panel Boards",
            items: ["Complete range based on industry standards"]
        },
        {
            category: "Solar Structures",
            items: ["MSS Solar Module Mounting Structures"]
        },
        {
            category: "Earthing Systems",
            items: [
                "Complete Earthing Management Solutions",
                "Electrodes, Backfills, & Accessories",
                "(Manufactured in partnership with MARUTHI EARTHINGS)"
            ]
        },
        {
            category: "Clamps & Accessories",
            items: [
                "All Types of Steel Clamps",
                "Cable Tray Clamps",
                "Support Brackets & Hardware"
            ]
        },
        {
            category: "UPVC Reinforcement",
            items: [
                "Structure-based reinforcements (as per sample requirements)",
                "False Ceiling Channels"
            ]
        },
        {
            category: "Electrical Goods & Accessories",
            items: ["Industrial-grade electrical components & accessories"]
        }
    ];

    return (
        <div className="about-area rn-section-gap products-section">
            <div className="container">

                {/* CENTER TITLE */}
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <h3 className="title">Products We Manufacture</h3>
                        <p className="description" 
                            style={{ maxWidth: "700px", margin: "10px auto 40px auto" }}>
                            Delivering high-quality electrical infrastructure products for industries across India.
                        </p>
                    </div>
                </div>

                {/* PRODUCT LIST GRID */}
                <div className="row">
                    <div className="col-lg-12">
                        <div
                            className="products-grid"
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "30px 40px",
                                maxWidth: "1000px",
                                margin: "0 auto"
                            }}
                        >
                            {products.map((product, index) => (
                                <div key={index}>
                                    
                                    {/* CATEGORY TITLE */}
                                    <h4 
                                        className="subtitle"
                                        style={{ marginBottom: "12px", fontWeight: "600" }}
                                    >
                                        {index + 1}. {product.category}
                                    </h4>

                                    {/* CATEGORY ITEMS */}
                                    <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                        {product.items.map((item, i) => (
                                            <li 
                                                key={i}
                                                style={{ 
                                                    display: "flex", 
                                                    alignItems: "center",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <FiCheck style={{ marginRight: "8px" }} />
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>

                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ProductsWeManufacture;
